module.exports = __webpack_public_path__ + "static/media/mouse.3eeba7db.png";